<rdx-no-navigation-header />
<router-outlet />
